<template>
	<div class="notice-list-component">
		<div class="notice-list-header" v-if="noticeList.length > 0">
			<div class="notice-list-header-btns">
				<span>全部已读</span>
			</div>
			<div class="notice-list-header-filter">
				<span>全部</span>
			</div>
		</div>
		<div class="notice-list" v-if="noticeList.length > 0">
			<div class="notice-list-each" v-for="(item, index) in noticeList" :key="index">
				<div class="notice-list-each-user-headImg">
					<img src="../../assets/common/userHeadImg_Default.png" />
				</div>
				<div class="notice-list-each-user">
					<div class="notice-list-each-user-info">
						<span class="notice-list-each-user-name">{{item.name}}</span>
						<span class="notice-list-each-user-operation" v-if="item.operate == 1">创建了新的日程</span>
						<span class="notice-list-each-user-operation userOption-edit"
							v-if="item.operate == 2">修改了日程</span>
						<span class="notice-list-each-user-operation userOption-delete"
							v-if="item.operate == 3">删除了日程</span>
					</div>
					<div class="notice-list-each-schedule-info">
						<span>{{item.scheduleInfo.start_time}}</span>
						<span>{{item.scheduleInfo.location}}</span>
						<span>{{item.scheduleInfo.content}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="notice-list-footer" @click="loadMoreNotices" v-if="noticeList.length > 0">
			<span>查看更多</span>
		</div>
		<div class="notice-list-noData" v-if="noticeList.length == 0">
			<span>暂无新消息</span>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				noticeList: [], //通知列表
				page: 1, //通知列表当前页
				size: 10, //通知列表每次请求条数
				userId: '', //当前登录用户Id
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				let userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.userId = userInfo.id;
				that.getContentOperateLogView();
			})
		},
		methods: {
			//获取日程变更通知
			getContentOperateLogView() {
				let that = this;
				let params = {
					page: that.page,
					size: that.size,
					userId: that.userId
				};
				that.$api.getContentOperateLogView(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						res.data.forEach((item, index) => {
							item.scheduleInfo = JSON.parse(item.content);
							item.scheduleInfo.start_time = that.$utils.fmtDate(new Date(item.scheduleInfo
								.startTime), "yyyy-MM-dd hh:mm");
						})
						that.noticeList = res.data;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//点击加载更多通知
			loadMoreNotices() {
				let that = this;
				that.page = that.page + 1;
				that.getContentOperateLogView();
			}
		}
	}
</script>

<style lang="scss">
	.notice-list-component {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;

		.notice-list-header {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
			width: 100%;

			.notice-list-header-btns {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-end;
				width: 100%;

				span {
					font-weight: 400;
					color: #666666;
				}
			}

			.notice-list-header-filter {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				span {
					font-weight: 400;
					color: #333333;
				}
			}
		}

		.notice-list {
			overflow-y: scroll;
			box-sizing: border-box;

			.notice-list-each {
				display: flex;
				flex-direction: row;
				align-items: flex-start;
				justify-content: flex-start;
				cursor: pointer;

				.notice-list-each-user-headImg {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;

					img {}
				}

				.notice-list-each-user {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					justify-content: center;

					.notice-list-each-user-info {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: flex-start;

						.notice-list-each-user-name {
							font-weight: 400;
							color: #666666;
						}

						.notice-list-each-user-operation {
							font-weight: 400;
							color: #3F79F7;
						}

						.userOption-edit {
							color: #F6600E;
						}

						.userOption-delete {
							color: #FD0E24;
						}
					}

					.notice-list-each-schedule-info {
						display: flex;
						flex-direction: column;
						align-items: flex-start;
						justify-content: center;

						span {
							font-weight: 400;
							color: #333333;
						}
					}
				}
			}

			.notice-list-each:hover {
				background-color: #E8EFFF;
			}
		}

		.notice-list-footer {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 100%;
			cursor: pointer;
		}

		.notice-list-noData {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 100%;

			span {
				color: #999999;
			}
		}
	}

	@media screen and (min-width: 1024px) {
		.notice-list-component {
			.notice-list-header {
				.notice-list-header-btns {
					span {
						font-size: 15px;
					}
				}
		
				.notice-list-header-filter {
					span {
						font-size: 15px;
					}
				}
			}
		
			.notice-list {
				margin: 20px 0;
				padding: 0 10px;
				width: calc(100% - 10px);
				max-height: 390px;
		
				.notice-list-each {
					padding: 10px;
					width: calc(100% - 20px);
		
					.notice-list-each-user-headImg {
						img {
							width: 37px;
							height: 37px;
						}
					}
		
					.notice-list-each-user {
						margin: 0 0 0 9px;
		
						.notice-list-each-user-info {
							height: 37px;
							line-height: 37px;
		
							.notice-list-each-user-name {
								font-size: 14px;
							}
		
							.notice-list-each-user-operation {
								margin: 0 0 0 17px;
								font-size: 14px;
							}
						}
		
						.notice-list-each-schedule-info {
							span {
								font-size: 14px;
							}
						}
					}
				}
		
				.notice-list-each:hover {
					border-radius: 6px;
				}
			}
		
			.notice-list-footer {
				span {
					font-size: 14px;
				}
			}
		
			.notice-list-noData {
				margin: 12px 0;
		
				span {
					font-size: 14px;
				}
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.notice-list-component {
			.notice-list-header {
				.notice-list-header-btns {
					span {
						font-size: 24px;
					}
				}

				.notice-list-header-filter {
					span {
						font-size: 24px;
					}
				}
			}

			.notice-list {
				margin: 20px 0;
				width: calc(100% - 10px);
				max-height: 600px;

				.notice-list-each {
					padding: 10px;
					width: calc(100% - 20px);

					.notice-list-each-user-headImg {
						img {
							width: 48px;
							height: 48px;
						}
					}

					.notice-list-each-user {
						margin: 0 0 0 12px;

						.notice-list-each-user-info {
							height: 48px;
							line-height: 48px;

							.notice-list-each-user-name {
								font-size: 22px;
							}

							.notice-list-each-user-operation {
								margin: 0 0 0 28px;
								font-size: 22px;
							}
						}

						.notice-list-each-schedule-info {
							span {
								font-size: 20px;
							}
						}
					}
				}

				.notice-list-each:hover {
					border-radius: 11px;
				}
			}

			.notice-list-footer {
				span {
					font-size: 24px;
				}
			}

			.notice-list-noData {
				margin: 20px 0;

				span {
					font-size: 24px;
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>